jQuery( function( $ ) {
    "use strict";

    var $archive = $( '[data-product-category-archive]' );
    var $toolbar = $( '[data-product-toolbar]' );
    var $loading = $archive.find( '[data-product-category-loading]' );
    var archive_type = $archive.attr( 'data-product-archive-type' );
    var storage_key = 'vector-product-view';
    var ajax_data = $.extend( {}, window.vectorProductListData || {}, {
        ajaxUrl: $archive.attr( 'data-product-ajax-url' ),
        action: $archive.attr( 'data-product-ajax-action' ),
        nonce: $archive.attr( 'data-product-ajax-nonce' ),
        category: $archive.attr( 'data-product-category' ),
        marketTerm: parseInt( $archive.attr( 'data-market-term' ), 10 ) || 0,
        marketFilter: $archive.attr( 'data-market-filter' ) === '1',
        filterQueryVar: $archive.attr( 'data-product-filter-query-var' ) || 'product_cat_filter',
        perPage: $archive.attr( 'data-product-per-page' )
    } );
    var active_request = null;
    var request_id = 0;

    function getStoredView() {
        try {
            return window.localStorage.getItem( storage_key );
        } catch ( error ) {
            return null;
        }
    }

    function storeView( view ) {
        try {
            window.localStorage.setItem( storage_key, view );
        } catch ( error ) {
            // Local storage may be unavailable in private browsing contexts.
        }
    }

    function setView( view ) {
        var is_list = 'list' === view;
        var $products = $( '.woocommerce ul.products, .woocommerce-page ul.products' );

        $products.toggleClass( 'is-list-view', is_list );

        $toolbar.find( '[data-product-view]' ).each( function() {
            var $button = $( this );
            var is_active = $button.data( 'product-view' ) === view;

            $button.toggleClass( 'is-active', is_active );
            $button.attr( 'aria-pressed', is_active ? 'true' : 'false' );
        } );
    }

    function isMobileProductLayout() {
        return window.matchMedia && window.matchMedia( '(max-width: 1079.98px)' ).matches;
    }

    function getViewForViewport() {
        return ! isMobileProductLayout() && 'list' === getStoredView() ? 'list' : 'grid';
    }

    function getSelectedFilters() {
        var selected = [];

        $archive.find( '[data-product-category-filter] input[type="checkbox"]:checked' ).each( function() {
            selected.push( $( this ).val() );
        } );

        return selected;
    }

    function getQueryFromControls() {
        var params = new URLSearchParams();
        var search = $.trim( $archive.find( '[data-product-search] input[name="s"]' ).val() || '' );

        if ( search ) {
            params.set( 's', search );
            params.set( 'post_type', 'product' );
        }

        if ( ajax_data.marketTerm ) {
            params.set( 'market_term', ajax_data.marketTerm );
        }

        getSelectedFilters().forEach( function( filter ) {
            params.append( ajax_data.filterQueryVar + '[]', filter );
        } );

        return params;
    }

    function getPublicUrl( params ) {
        var public_params = new URLSearchParams( params.toString() );

        if ( window.location.pathname.indexOf( '/shop/market-category/' ) !== -1 ) {
            public_params.delete( 'market_term' );
        }

        var query = public_params.toString();

        return window.location.pathname + ( query ? '?' + query : '' ) + window.location.hash;
    }

    function syncControlsFromQuery( params ) {
        var search = params.get( 's' ) || '';
        var selected = params.getAll( ajax_data.filterQueryVar + '[]' );

        $archive.find( '[data-product-search] input[name="s"]' ).val( search );
        $archive.find( '[data-product-category-filter] input[type="checkbox"]' ).each( function() {
            $( this ).prop( 'checked', selected.indexOf( $( this ).val() ) !== -1 );
        } );
    }

    function syncToolbarFilters( selected ) {
        var $search_form = $archive.find( '[data-product-search]' );

        $search_form.find( 'input[name="' + ajax_data.filterQueryVar + '[]"]' ).remove();

        selected.forEach( function( filter ) {
            $( '<input>', {
                type: 'hidden',
                name: ajax_data.filterQueryVar + '[]',
                value: filter
            } ).appendTo( $search_form );
        } );
    }

    function ajaxIsAvailable() {
        return $archive.length && ajax_data.ajaxUrl && ajax_data.action && ajax_data.nonce && ( 'shop' === archive_type || ajax_data.category );
    }

    function setLoading( is_loading ) {
        $loading.prop( 'hidden', ! is_loading );
    }

    function requestArchive( params ) {
        if ( ! ajaxIsAvailable() ) {
            window.location.assign( getPublicUrl( params || getQueryFromControls() ) );
            return;
        }

        params = params || getQueryFromControls();
        syncControlsFromQuery( params );

        var selected = getSelectedFilters();
        var public_url = getPublicUrl( params );
        var current_request_id = ++request_id;
        var request_data = {
            action: ajax_data.action,
            nonce: ajax_data.nonce,
            category: ajax_data.category,
            market_term: params.get( 'market_term' ) || ajax_data.marketTerm || '',
            market_filter: ajax_data.marketFilter ? '1' : '0',
            s: params.get( 's' ) || '',
            per_page: ajax_data.perPage || 0
        };
        request_data[ ajax_data.filterQueryVar ] = selected;

        if ( active_request ) {
            active_request.abort();
        }

        $archive.attr( 'aria-busy', 'true' ).addClass( 'is-loading' );
        setLoading( true );

        active_request = $.ajax( {
            url: ajax_data.ajaxUrl,
            method: 'POST',
            data: request_data,
            dataType: 'json'
        } ).done( function( response ) {
            if ( current_request_id !== request_id || ! response.success || ! response.data ) {
                return;
            }

            var $sidebar = $archive.find( '[data-product-category-sidebar]' );
            var $results = $archive.find( '[data-product-category-results]' );

            if ( $sidebar.length && response.data.filter_html ) {
                $sidebar.replaceWith( response.data.filter_html );
            }

            if ( $results.length ) {
                $results.html( response.data.results_html );
            }

            syncToolbarFilters( selected );
            window.history.pushState( { vectorProductArchive: true }, '', public_url );
            setView( getViewForViewport() );
        } ).fail( function( xhr, status ) {
            if ( 'abort' !== status && current_request_id === request_id ) {
                window.location.assign( public_url );
            }
        } ).always( function() {
            if ( current_request_id === request_id ) {
                $archive.removeAttr( 'aria-busy' ).removeClass( 'is-loading' );
                setLoading( false );
                active_request = null;
            }
        } );
    }

    setView( getViewForViewport() );

    $toolbar.on( 'click', '[data-product-view]', function() {
        var view = $( this ).data( 'product-view' );

        setView( view );
        storeView( view );
    } );

    if ( ! $archive.length ) {
        return;
    }

    $archive.find( '[data-product-search]' ).on( 'submit', function( event ) {
        if ( ! ajaxIsAvailable() ) {
            return;
        }

        event.preventDefault();
        requestArchive();
    } );

    $archive.on( 'change', '[data-product-category-filter] input[type="checkbox"]', function() {
        requestArchive();
    } );

    $archive.on( 'click', '[data-product-category-filter-clear]', function( event ) {
        if ( ! ajaxIsAvailable() ) {
            return;
        }

        event.preventDefault();

        var clear_url = new URL( this.href, window.location.href );

        syncControlsFromQuery( clear_url.searchParams );
        requestArchive( clear_url.searchParams );
    } );

    $( window ).on( 'popstate', function() {
        if ( ajaxIsAvailable() ) {
            requestArchive( new URLSearchParams( window.location.search ) );
        }
    } );

    $( window ).on( 'resize', function() {
        setView( getViewForViewport() );
    } );
} );



// WEBPACK FOOTER //
// ./resources/assets/scripts/woocommerce-product-list.js